import React from 'react'
import { getProducts } from './../../content'

import './InsuranceProducts.component.scss'

const hideOnError = e => {
  e.target.style.display = 'none'
}

const InsuranceProducts = ({ subsiteData }) => {
  const products = getProducts(subsiteData)

  return (
    <section id='InsuranceProducts' className='subsite-section'>
      <div className='subsite-shell'>
        <h2 className='subsite-section-title'>Our Insurance Products</h2>
        <p className='subsite-section-subtitle'>Compare plans, explore options, and get covered faster.</p>
        <div className='products-list'>
          {products.map(product => (
            <div className='product-row' key={product.key}>
              <div className='product-media'>
                {product.image ? <img src={product.image} alt={product.title} onError={hideOnError} /> : <></>}
              </div>
              <div className='product-content'>
                <h3>{product.title}</h3>
                <p>{product.body}</p>
                <a className='subsite-btn' href={product.link}>
                  Explore Coverage Options
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default InsuranceProducts
